import './Icon.css';
import { ICONS, type IconName } from './icons';

export interface IconProps {
  name: IconName;
  /** Inteiro de 11 a 20 px (§3.7.1); padrão 16. */
  size?: number;
  /** Só para as exceções do catálogo. */
  strokeWidth?: number;
}

/** Ícone do catálogo (§3.7): sempre decorativo; o nome acessível fica no botão que o contém. */
export function Icon({ name, size = 16, strokeWidth }: IconProps) {
  const def = ICONS[name];
  const px = Math.min(20, Math.max(11, Math.round(size)));
  const filled = def.stroke === null;
  return (
    <svg
      class={`icon icon--${name}`}
      width={px}
      height={px}
      viewBox={def.viewBox}
      fill={filled ? 'currentColor' : 'none'}
      stroke={filled ? 'none' : 'currentColor'}
      stroke-width={filled ? undefined : (strokeWidth ?? def.stroke ?? undefined)}
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {def.shapes.map(([tag, attrs], i) => {
        const Tag = tag;
        return <Tag key={i} {...attrs} />;
      })}
    </svg>
  );
}
